<template>
  <section class="wrapper">
    <van-form>
      <div v-for="(data,index) in formData" :key="i" class="mt10">
        <van-field
          input-align="right"
          readonly
          clickable
          v-model="formData[index].Date"
          :label="`记--${index+1}`"
          placeholder="请选择"
          @click="handleDate(index,true)"
        />
        <!--日期-->
        <van-popup v-model="showDatePicker[index]" position="bottom">
          <van-datetime-picker
            type="date"
            @confirm="value=>onShowPaymentDateConfirm(index,value)"
            @cancel="handleDate(index,false)"
          />
        </van-popup>
        <van-field
          input-align="right"
          v-model="formData[index].remark"
          rows="4"
          autosize
          label="摘要"
          type="textarea"
          placeholder="请输入"
        />
        <van-field
          input-align="right"
          readonly
          clickable
          v-model="formData[index].optionName"
          label="科目"
          placeholder="请选择一级科目"
          @click="handleFirstLevel(index,true)"
        />
        <!--一级科目弹窗-->
        <van-popup v-model="showFirstLevel[index]" position="bottom">
          <van-picker
            show-toolbar
            :columns="firstLevelList"
            @confirm="value=>onFirstLevelConfirm(index,value)"
            @cancel="handleFirstLevel(index,false)"
          />
        </van-popup>
        <van-field
          input-align="right"
          readonly
          clickable
          v-model="formData[index].Twolevel"
          placeholder="请选择二级科目"
          @click="handleSecondLevel(index,true)"
        />
        <!--二级科目弹窗-->
        <van-popup v-model="showSecondLevel[index]" position="bottom">
          <van-picker
            show-toolbar
            :columns="secondLevelList"
            @confirm="value=>onSecondLevelConfirm(index,value)"
            @cancel="handleSecondLevel(index,false)"
          />
        </van-popup>
        <van-field input-align="right" label="借贷方式">
          <template #input>
            <van-radio-group v-model="formData[index].type" direction="horizontal" @change="count">
              <van-radio :name="1">借</van-radio>
              <van-radio :name="2">贷</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          input-align="right"
          v-model="formData[index].summary"
          rows="1"
          autosize
          label="金额"
          type="textarea"
          placeholder="请输入"
          @blur="count"
        />
      </div>
    </van-form>
    <div class="add text-right" @click="addFormData">
      <van-icon name="plus"/>
      新增
    </div>
    <van-row class="total">
      <van-col :span="12">借方合计：{{total.debit}}</van-col>
      <van-col :span="12">贷方合计：{{total.credit}}</van-col>
    </van-row>
    <van-field
      input-align="right"
      v-model="formData.summary"
      rows="1"
      autosize
      label="附单据"
      type="textarea"
      placeholder="请输入单据数量"
    >
      <template #button>
        <van-button size="small" type="primary">上传</van-button>
      </template>
    </van-field>
    <van-row :gutter="10" class="mt10">
      <van-col :span="12">
        <van-button round block type="primary" @click="UpdAccountRecords">提交</van-button>
      </van-col>
      <van-col :span="12">
        <van-button round block type="primary" plain>返回</van-button>
      </van-col>
    </van-row>

  </section>
</template>

<script>
  import {getUnionAccountListFun, updAccountRecordFun} from '@/api/voucher'
  import {getPartnersAllFun} from '@/api/payment'

  export default {
    data() {
      return {
        formData: [{
          remark: '',//摘要
          optionName: '',//一级科目
          Twolevel: '',//二级科目
          type: 1,//借贷方式
          summary: 0,//金额
          date: '',//日期
        }],
        showDatePicker: [false],//选择日期
        showFirstLevel: [false],//一级科目弹窗
        showSecondLevel: [false],//二级科目弹窗
        firstLevelList: [],//一级科目
        secondLevelList: [],//二级科目
        total: {
          debit: 0,
          credit: 0
        }
      }
    },
    mounted() {
      this.getUnionAccountList();
      this.getPartnersAll();
    },
    methods: {
      //获取一级科目
      async getUnionAccountList() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getUnionAccountListFun(params);
        if (response.success) {
          response.result.map(item => {
            this.firstLevelList.push({
              text: item.UinName,
              value: item.ID
            })
          });
        }
      },
      //  获取二级科目
      async getPartnersAll() {
        const params = {
          C_GUID: this.getCookie('CompanyInfo').companyId
        };
        const response = await getPartnersAllFun(params);
        if (response.success) {
          response.result.map(item => {
            this.secondLevelList.push({
              text: item.Name,
              value: item.BP_GUID
            })
          });
        }
      },
      handleDate(index,value) {
        this.$set(this.showDatePicker, index, value);
      },
      handleFirstLevel(index,value) {
        this.$set(this.showFirstLevel, index, value);
      },
      handleSecondLevel(index,value) {
        this.$set(this.showSecondLevel, index, value);
      },
      onShowPaymentDateConfirm(index, value) {
        this.$set(this.showDatePicker, index, false);
        this.formData[index].Date = this.moment(value).format('YYYY-MM-DD');
      },
      onFirstLevelConfirm(index, item) {
        this.$set(this.showFirstLevel, index, false);
        this.formData[index].optionName = item.text;
      },
      onSecondLevelConfirm(index, item) {
        this.$set(this.showSecondLevel, index, false);
        this.formData[index].Twolevel = item.text;
      },
      addFormData() {
        this.formData.push({
          remark: '',//摘要
          optionName: '',//一级科目
          Twolevel: '',//二级科目
          type: 1,//借贷方式
          summary: '',//金额
          date: '',//日期
        });
        this.showFirstLevel.push(false);
        this.showSecondLevel.push(false)
      },
      count() {
        this.formData.map(item => {
          if (item.type === 1) {
            this.total.debit += Number(item.summary)
          } else {
            this.total.credit += Number(item.summary)
          }
        })
      },
      //  提交凭证
      async UpdAccountRecords() {
        const response = await updAccountRecordFun(this.formData);
        if (response.success) {
          console.log(response);
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    padding: 0 1rem;

    .total, .add {
      background: white;
      padding: 1.5rem;
      color: #646566;
      font-size: 1.4rem;
      margin-top: 1rem;
    }
  }
</style>
